const fixedSaltValue = '$2a$10$'

export{
    fixedSaltValue,   
}